<template>
  <div class="noticeItem">
    <!-- 用户信息（保留头像和昵称） -->
    <div class="userInfo">
      <img :src="chatItem.avatar || defaultAvatar" alt="用户头像" />
    </div>

    <!-- 公告内容区域 -->
    <div class="noticeWrap">
      <div class="nickname">{{ chatItem.nickname }}</div>
      <div class="noticeContent">
        <span class="noticeTag">公告</span>
        <div class="noticeText" v-html="purifiedHtml"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { defaultAvatar } from "@/utils/constant";
import DOMPurify from 'dompurify';
import {mapGetters} from "vuex";
export default {
  name: "ChatNotice",
  props: {
    chatItem: {
      type: Object,
      required: true,
      default: () => ({
        avatar: "",
        nickname: "",
        content: ""
      })
    }
  },
  computed: {
    ...mapGetters(["live"]),
    purifiedHtml() {
      return DOMPurify.sanitize(this.chatItem.chatContext);
    }
  },
  data() {
    return {
      defaultAvatar: defaultAvatar
    };
  }
};
</script>

<style lang="less" scoped>
.noticeItem {
  display: flex;
  margin-bottom: 10px; // 原20px

  /* 用户头像 */
  .userInfo {
    margin-left: 25px; // 原50px
    img {
      width: 34px; // 原68px
      height: 34px; // 原68px
      border-radius: 50%;
    }
  }

  /* 公告内容区域 */
  .noticeWrap {
    margin-left: 6px; // 原12px
    max-width: 280px; // 原560px

    .nickname {
      color: #fff;
      font-size: 12px; // 原24px
      margin-bottom: 3px; // 原5px
      background-color: rgba(0,0,0,0.5);
      padding: 3px;
      border-radius: 3px;
      display: inline-flex;
    }

    .noticeContent {
      font-size: 13px; // 原26px
      line-height: 17px; // 原34px
      color: #262626;
      background: #FFF8E6;
      padding: 8px; // 原15px
      border-radius: 7px; // 原13px
      word-break: break-word;

      /* 公告标签 */
      .noticeTag {
        display: inline-block;
        background: #FF9500;
        color: white;
        font-size: 10px; // 原20px
        padding: 1px 4px; // 原2px 8px
        border-radius: 2px; // 原4px
        margin-right: 4px; // 原8px
      }

      .noticeText {
        line-height: 1.6;
      }
    }
  }
}
</style>